import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';

import { memberClient } from 'src/config/Apollo';
import { ServiceType } from 'src/generated/webapp_gql';

import { ChooseCPTCode } from './ChooseCPTCode';
import { ChooseDXCodes } from './ChooseDXCodes';

interface Props {
  companyUuid: string;
  serviceType: ServiceType;
  onSelectCptCode: (code: string) => void;
  onSelectPrimaryDiagnosisCode: (code: string) => void;
  onSelectSecondaryDiagnosisCodes: (codes: string[]) => void;
  disabled: boolean;
}

export enum BillingCodesFormTestID {
  Container = 'BillingCodesFormTestID.Container',
}

const BILLING_ROW = 'mt-0 mx-8 mb-1';

const useStyles = makeStyles({
  wrapper: {
    position: 'relative',
  },
  disabledCover: {
    backgroundColor: 'white',
    opacity: 0.7,
    zIndex: 20,
    height: '100%',
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position: 'absolute',
    top: '0px',
    left: '0px',
  },
});

export const BillingCodesForm: React.FC<Props> = ({
  companyUuid,
  serviceType,
  onSelectCptCode,
  onSelectPrimaryDiagnosisCode,
  onSelectSecondaryDiagnosisCodes,
  disabled,
}: Props) => {
  const [cptCodeChosen, setCptCodeChosen] = useState<string | undefined>();

  const handleCptCodeSelected = (code: string) => {
    setCptCodeChosen(code);
    onSelectCptCode(code);
  };

  const handlePrimaryDiagnosisSelected = (code: string) => onSelectPrimaryDiagnosisCode(code);
  const handleSecondaryDiagnosisSelected = (codes: string[]) =>
    onSelectSecondaryDiagnosisCodes(codes);
  const classes = useStyles();
  const disabledCover = disabled ? classes.disabledCover : '';

  return (
    <div data-testid={BillingCodesFormTestID.Container} className={classes.wrapper}>
      <div className={disabledCover}></div>
      <div className="mt-0 mx-8 mb-4">
        <span className="font-extrabold text-gray-900 text-xl">
          <span className="text-blue-400 mb-4">Step 2:</span> Billing details
        </span>
      </div>
      <div className={BILLING_ROW}>
        <ChooseCPTCode
          companyUuid={companyUuid}
          serviceType={serviceType}
          onSelectCptCode={handleCptCodeSelected}
          selectedCptCode={cptCodeChosen}
          memberClient={memberClient}
        />
      </div>
      <div className={BILLING_ROW}>
        <ChooseDXCodes
          onPrimaryCodeSelected={handlePrimaryDiagnosisSelected}
          onSecondaryCodeSelected={handleSecondaryDiagnosisSelected}
          memberClient={memberClient}
        />
      </div>
    </div>
  );
};
